import { WooCommerceCartItem } from '../../../core/interfaces/woo-commerce/api/cart/cart.interface';
import { WooCommerceCoupon } from '../../../core/interfaces/woo-commerce/api/coupon/coupon-api.interface';
import {
  WooCommercePostCartItemBody,
  WooCommercePutCartItemParameters
} from '../../../core/interfaces/woo-commerce/cart/cart.interface';

export interface CartItemsActionGetPayload {
  forceUpdate: boolean;
}

export namespace CartItemsAction {
  export class Get {
    static readonly type: string = '[Cart] Get Cart Items';

    constructor(public payload?: CartItemsActionGetPayload) {}
  }

  export class Sync {
    static readonly type: string = '[Cart] Sync Cart Items';
  }

  export class Add {
    static readonly type: string = '[Cart] Add Cart Item';

    constructor(
      public payload: WooCommercePostCartItemBody,
      public displayData?: Partial<WooCommerceCartItem>
    ) {}
  }

  export class Update {
    static readonly type: string = '[Cart] Update Cart Item';

    constructor(public payload: WooCommercePutCartItemParameters) {}
  }

  export class Remove {
    static readonly type: string = '[Cart] Remove Cart Item';

    constructor(public payload: string) {}
  }

  export class Clear {
    static readonly type: string = '[Cart] Clear Cart';
  }
}

export namespace CartCouponAction {
  export class Get {
    static readonly type: string = '[Cart] Get Cart Coupon';
  }

  export class Add {
    static readonly type: string = '[Cart] Add Cart Coupon';

    constructor(public payload: string) {}
  }

  export class Remove {
    static readonly type: string = '[Cart] Remove Cart Coupon';

    constructor(public payload: WooCommerceCoupon) {}
  }
}

export namespace CartRewardPointsAction {
  export class Set {
    static readonly type: string = '[Cart] Set Reward Points';

    constructor(public payload: number) {}
  }

  export class Remove {
    static readonly type: string = '[Cart] Remove Reward Points';
  }
}
